export const queryKeys = {
  chat: {
    prompts: ['chat', 'prompts'] as const,
    history: (sessionId?: string) => ['chat', 'history', sessionId ?? 'missing'] as const,
  },
  profile: (userId?: string) => ['profile', userId ?? 'anonymous'] as const,
  subscription: (userId?: string) =>
    ['subscription', userId ?? 'anonymous'] as const,
  usage: ['subscription', 'usage'] as const,
  planCatalog: ['subscription', 'plan-catalog'] as const,
  briefing: {
    today: ['briefing', 'today'] as const,
  },
  ahead: {
    all: ['ahead'] as const,
    list: ['ahead', 'list'] as const,
    detail: (id?: string) => ['ahead', 'detail', id ?? 'unknown'] as const,
    count: ['ahead', 'count'] as const,
  },
  handoff: {
    current: ['handoff', 'current'] as const,
    shared: (token?: string) => ['handoff', 'shared', token ?? 'missing'] as const,
  },
  goals: {
    suggestions: ['goals', 'suggestions'] as const,
    list: ['goals', 'list'] as const,
    detail: (id?: string) => ['goals', 'detail', id ?? 'unknown'] as const,
  },
  walk: {
    snapshot: (token?: string) => ['walk', 'snapshot', token ?? 'missing'] as const,
  },
  clip: {
    snapshot: (token?: string) => ['clip', 'snapshot', token ?? 'missing'] as const,
  },
  connectors: {
    portalList: ['connectors', 'portal-list'] as const,
    available: ['connectors', 'available'] as const,
    status: (userId?: string) => ['connectors', 'status', userId ?? 'anonymous'] as const,
  },
  settings: {
    privacy: ['settings', 'privacy'] as const,
    mfa: ['settings', 'mfa'] as const,
    medical: ['settings', 'medical'] as const,
  },
  org: {
    ssoConfig: (slug?: string) => ['org', 'sso-config', slug ?? 'missing'] as const,
    dashboard: (slug?: string) => ['org', 'dashboard', slug ?? 'missing'] as const,
    membersPrefix: (slug?: string) => ['org', 'members', slug ?? 'missing'] as const,
    members: (
      slug?: string,
      page?: number,
      pageSize?: number,
      status?: string,
      search?: string
    ) => ['org', 'members', slug ?? 'missing', page ?? 1, pageSize ?? 25, status ?? '', search ?? ''] as const,
    engagement: (slug?: string, period?: string) =>
      ['org', 'engagement', slug ?? 'missing', period ?? '30d'] as const,
    billing: (slug?: string) => ['org', 'billing', slug ?? 'missing'] as const,
    settings: (slug?: string) => ['org', 'settings', slug ?? 'missing'] as const,
  },
}
